module.exports = __webpack_public_path__ + "static/media/boy-4.ec828814.svg";